import gql from 'graphql-tag';

export const SET_TEMPLATE_ACTIVE_STATUS = gql`
  mutation SetTemplateActiveStatus($input: SetTemplateActiveStatusInput!) {
    bpf {
      result: setTemplateActiveStatus(input: $input) {
        error
        success
        entity {
          businessProcessFlowId
        }
      }
    }
  }
`;
